import React from 'react';
import { Anchor, Breadcrumbs } from "@mantine/core";
import { useNavigate, useParams } from "react-router-dom";
import S from './PartnerCard.module.scss';
import { partnersData } from "../../shared/mock/partners";
import {MonitorElectric} from "./additionalnformation";
import {GazTechnologies} from "./additionalnformation";

export const PartnerCard = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const partner = partnersData.find((item) => item.id.toString() === id);

  if (!partner) return <div>Партнер не найден</div>;

  const items = [
    { title: 'Главная', url: '/' },
    { title: 'Бренды', url: '/brands' },
    { title: partner.title, active: true },
  ].map((item, index) => (
    <Anchor onClick={() => item.url && navigate(item.url)} key={index} data-active={item.active || undefined}>
      {item.title}
    </Anchor>
  ));

  return (
    <section className={S.section} id='brands-list'>
      <div className={S.brands_content}>
        <Breadcrumbs className={S.breadcrumbs}>{items}</Breadcrumbs>

        <h1>{partner.title}</h1>

        <div className={S.mainLayout}>
          <div className={S.sidebar}>
            <div className={S.card}>
              <img src={partner.images} alt={partner.title} />
            </div>
          </div>

          <div className={S.info}>
            <div className={S.description}>
              {partner.description.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
              {partner?.infoMonitorElectric && <MonitorElectric/>}
              {partner?.infoGazTechnologies && <GazTechnologies/>}
            </div>

            <div className={S.contacts}>
              {partner.site && (
                  <a href={partner.site} target="_blank" rel="noreferrer">
                    {partner.site}
                  </a>
              )}
              {partner.email && (
                  <a href={`mailto:${partner.email}`}>
                  {partner.email}
                  </a>
              )}
              {partner.phone && (
                <a href={`tel:${partner.phone.replace(/\s/g, '')}`}>
                  {partner.phone}
                </a>
              )}
            </div>
          </div>
        </div>

        <div className={S.footer}>
          <div onClick={() => navigate('/brands')}>← Назад к списку</div>
        </div>
      </div>
    </section>
  );
};
